import React, { FunctionComponent } from 'react';

interface IDashboard {}

const Dashboard: FunctionComponent<IDashboard> = () => {
  return <></>;
};

export default Dashboard;
